import IntlMessages from '../IntlMessages';
import moment       from 'moment';
import 'moment-timezone';
import I18n         from "../../utils/I18n";


// TODO : refactor with EventHelpers

const lang = I18n.lang();

moment.locale(lang);
moment.tz.setDefault("Europe/Luxembourg");


function asc2hex(pStr) {
    let tempstr = "";
    let a = 0;
    while (a < pStr.length) {
        tempstr = tempstr + pStr.charCodeAt(a).toString(16);
        a = a + 1;
    }
    return tempstr;
}

function hex2asc(pStr) {
    let tempstr = "";
    let b = 0;
    while (b < pStr.length) {
        tempstr = tempstr + String.fromCharCode(parseInt(pStr.substr(b, 2), 16));
        b = b + 2;
    }
    return tempstr;
}



export default class MovieHelpers {

    static getLang() {
        if(lang==="pt") return "fr";
        return lang;
    }

    static buildUrlParam( org ) {
        return asc2hex( org );
    }

    static decodeUrlParam( enc ) {
        return hex2asc( enc );
    }

    static pad(number) {
        if( number < 10 ) {
            return `0${number}`;
        } else {
            return number;
        }
    }

    static formatHour( ms ) {
        const hours = Math.floor( ms / 1000 / 3600 );
        const minutes = ( (ms / 1000 / 60) - (hours * 60) );
        return hours + 'h' + MovieHelpers.pad( minutes );
    }


    static formatDate( dateString ){
        const date = moment( dateString );
        return date.format( 'LL' );
    }

    static formatTime( dateString ){
        const date = moment( dateString );
        const utcOffset = dateString.substring(dateString.indexOf("+"));
        return date.utcOffset(utcOffset).format( 'HH:mm' );
    }

    static formatAddress( event ) {
        return event.address.streetNumber + ' ' + event.address.streetName;
    }

    static formatPrice( event ) {
        if( event.price.from === 0 ) {
            return IntlMessages[lang].free;
        } else if( event.price.to > 0 ) {
            return event.price.from + IntlMessages[lang].priceTo + event.price.to;
        } else {
            return event.price.from;
        }
    }

    static formatText( text ) {
        let exp = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
        return text.replace(/(?:\r\n|\r|\n)/g, '<br />').replace( exp, '<a href="$1">$1</a>' );
    }

    static safeLinkUrl( url ) {
        if( url.indexOf( 'http://' ) >= 0 ) {
            return url;
        } else {
            return `http://${url}`;
        }
    }

    static safeMovieDuration(duration) {
        if (duration > 0) {
            return duration + IntlMessages[lang].durationMinutes;
        } else {
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./js/movies/utils/MovieHelpers.js